import { render, staticRenderFns } from "./Tyre.vue?vue&type=template&id=3c2a6146&scoped=true"
import script from "./Tyre.vue?vue&type=script&lang=js"
export * from "./Tyre.vue?vue&type=script&lang=js"
import style0 from "./Tyre.vue?vue&type=style&index=0&id=3c2a6146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a6146",
  null
  
)

export default component.exports